import { formatBrl } from '@estac1/shared';
import { Card, CardContent } from '@estac1/ui';
import { KpiCard } from '../clients/kpi-card.js';
import type { ClientOverview } from './types.js';

/** O movimento do lote (#656): janelas de tickets, pátio agora e a série de 30 dias. */
export const UsageSection = ({ usage }: { usage: ClientOverview['usage'] }) => {
  const peak = Math.max(1, ...usage.daily.map((d) => d.opened));
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        <KpiCard label="No pátio agora" value={String(usage.openNow)} />
        <KpiCard
          label="Tickets hoje"
          value={String(usage.opened.today)}
          hint={`${usage.closed.today} fechados`}
        />
        <KpiCard
          label="Últimos 7 dias"
          value={String(usage.opened.last7)}
          hint={`${usage.closed.last7} fechados`}
        />
        <KpiCard
          label="Últimos 30 dias"
          value={String(usage.opened.last30)}
          hint={`${usage.valetLast30} de valet`}
        />
        <KpiCard label="Faturamento 30 dias" value={formatBrl(usage.revenueLast30Cents)} />
        <KpiCard label="Ticket médio" value={formatBrl(usage.averageTicketLast30Cents)} />
        <KpiCard label="Mensalistas" value={String(usage.monthlySubscribers)} />
        <KpiCard label="Lojas conveniadas" value={String(usage.partners)} />
      </div>
      <Card>
        <CardContent className="space-y-2 pt-6">
          <p className="text-sm font-medium">Tickets abertos por dia</p>
          <div
            className="flex h-24 items-end gap-0.5"
            role="img"
            aria-label="Tickets abertos nos últimos 30 dias"
          >
            {usage.daily.map((d) => (
              <div
                key={d.date}
                title={`${d.date.split('-').reverse().join('/')}: ${d.opened}`}
                className="flex-1 rounded-t bg-brand"
                style={{
                  height: `${Math.max(2, (d.opened / peak) * 100)}%`,
                  opacity: d.opened ? 1 : 0.25,
                }}
              />
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
